export const getSocketConfig = (token: string, language: string) => {
  const spamMode = localStorage.getItem("spamMode");
  const spamSystem = localStorage.getItem("spamSystem");
  const spamBonus = localStorage.getItem("spamBonus");

  return {
    withCredentials: true,
    transports: ["polling", "websocket"],
    auth: {
      token,
      spam: Boolean(spamMode),
      spamSystem: Boolean(spamSystem),
      spamBonus: Boolean(spamBonus),
    },
    query: {
      userLanguage: language.toLowerCase(),
    },
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: 20,
  };
};
